import React from "react";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";

const HomeButton = ({ icon, label, onClick, image, esDUO }) => {
  const theme = useTheme();
  const isFullLabel = label === "FULL";
  const isMobile = window.innerWidth < 700;
  const habilitaTiendaFull = JSON.parse(localStorage.getItem("habilitaTiendaFull")) || false;
  const solicitarAforadores = JSON.parse(localStorage.getItem("solicitarAforadores")) || false;
  // Configuración del border para el botón FULL
  const getBorderStyles = () => {
    if (!isFullLabel) return {};

    return isMobile
      ? {
          borderTop: "2px solid #000",
          borderBottom: "2px solid #000",
        }
      : {
          border: "2px solid #000",
        };
  };

  const buttonStyles = {
    margin: "0 auto",
    height: isMobile ? (solicitarAforadores && habilitaTiendaFull ? 70 : 85) : esDUO? 110 :98,
    width: isFullLabel && isMobile ? "97%" : "100%",
    maxWidth: esDUO? "460px" : "360px",
    backgroundColor: isFullLabel ? "white" : theme.bandera.colorSecundario,

    borderRadius: 0,
    marginBottom: 1,
    ...(isFullLabel && { border: "3px solid #000", borderRadius: 2 }),
    color: isFullLabel ? "black" : (theme.bandera.colorTextoBoton || "white"),
    ":hover": {
      backgroundColor: theme.bandera.colorSecundario,
      ...(isFullLabel && {
        color: "white",
      }),
    },
  };
  return (
    <Button sx={buttonStyles} onClick={onClick}>
      <div style={{ position: "relative", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        {image ? (
          <img
            src={image}
            alt={label}
            style={{
              position: "absolute",
              width: isMobile ? theme.bandera.anchoLogoTienda : esDUO? 100 : 80,
              height: isMobile ? 'auto' : esDUO? 100 :80,
              objectFit: "contain",
              filter: theme.bandera.colorIconoBoton === "#000" ? "brightness(0) saturate(100%)" : "none",
            }}
          />
        ) : (
          <div style={{ position: "absolute", left: 10 }}>{icon}</div>
        )}
        {!isFullLabel && (
          <p
            style={{
              fontSize: esDUO? 24 : 17,
              color: theme.bandera.colorTextoBoton || "white",
              lineHeight: "20px",
              letterSpacing: 0.3,
              textAlign: "center",
              fontWeight: 600,
              margin: 0,
              width: "100%",
              paddingLeft: 70,
            }}
          >
            {label}
          </p>
        )}
      </div>
    </Button>
  );
};

export default HomeButton;
